import React from 'react';
import ReactDOM from 'react-dom/client';
import { LogtoProvider, type LogtoConfig } from '@logto/react';
import { App } from './App';
import { ADMIN_SCOPE, config } from './config';

const logtoConfig: LogtoConfig = {
  endpoint: config.logtoEndpoint,
  appId: config.logtoAppId,
  // The DeskTouch API is a resource-server; the token's `aud` must match this
  // string exactly or every request is rejected by the API's JWT guard.
  resources: [config.apiResource],
  // The Logto browser SDK requests this scope on top of `openid profile`,
  // and Logto includes it in the issued token when the user's role carries it.
  scopes: [ADMIN_SCOPE],
};

const root = document.getElementById('root');
if (!root) throw new Error('missing #root — the shell HTML must be served');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <LogtoProvider config={logtoConfig}>
      <App />
    </LogtoProvider>
  </React.StrictMode>,
);
